module.exports = __webpack_public_path__ + "static/media/push.e4d046e0.mp3";